import { FC, useEffect, useState } from "react";
import { Button } from "../TrueUI";
import { useApiPost } from "../../hooks";
import { ImpersonateUserInfoDto } from "../../dtos/impersonate-user-info-dto";
import { isAPITotallyCompleteNoContentResponse } from "../../utilities/apiFunctions";
import DialogConfirmation from "../TrueUI/Dialogs/DialogConfirmation";
import { IMPERSONATE_INFO } from "../../utilities/queryStringsHash";

const ImpersonateButton: FC<{ userId: number }> = ({ userId }) => {
  const [isDialogOpen, setIsDialogOpen] = useState<boolean>(false);

  const buttonProps = {
    variantStyle: "outlined",
    sx: { margin: "10px" },
    width: "150px",
  };

  const {
    responsePost: responseImpersonate,
    dispatchPost: dispatchImpersonate,
  } = useApiPost<ImpersonateUserInfoDto>(
    `api/PortalUser/ImpersonateUser?impersonateUserId=${userId}`
  );

  const onImpersonateClick = () => {
    dispatchImpersonate();
  };

  useEffect(() => {
    if (isAPITotallyCompleteNoContentResponse(responseImpersonate)) {
      const impersonateData = responseImpersonate?.axiosResponse?.data;
      if (impersonateData?.hasAccess === true) {
        window.open(
          `${impersonateData?.portalURL ?? ""}?${IMPERSONATE_INFO}=${
            impersonateData?.token
          }`,
          "_blank",
          "width=800,height=600,resizable=yes,scrollbars=yes"
        );
      }
      if (impersonateData?.hasAccess === false) {
        setIsDialogOpen(true);
      }
    }
  }, [responseImpersonate]);

  return (
    <>
      <Button {...(buttonProps as any)} onClick={onImpersonateClick}>
        IMPERSONATE USER
      </Button>
      <DialogConfirmation
        open={isDialogOpen}
        dialogDescriptionText={"You are not allowed to do impersonation."}
        onOptionYesEvent={() => {
          setIsDialogOpen(false);
        }}
        optionYesOverrideLabel="Close"
      />
    </>
  );
};
export default ImpersonateButton;
